import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./promo.css";
import Header from "../components/Header";

// Import Swiper React components và styles (Cú pháp chuẩn version 8)
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

function Promotion() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")) || []);
    const [profile, setProfile] = useState(null);
    const [notifyItem, setNotifyItem] = useState();
    const [isShow, setShow] = useState(false);
    
    // State lưu danh sách Category (Đã sắp xếp)
    const [categories, setCategories] = useState(["Tất cả"]);
    
    // State cho thanh lọc category (Giao diện)
    const [activeCategory, setActiveCategory] = useState("Tất cả");
    
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (JSON.stringify(notify) !== JSON.stringify(res.data.data)) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });

        // LẤY VÀ SẮP XẾP DANH SÁCH DANH MỤC TỪ BACKEND
        axios.get(`${process.env.REACT_APP_API_URL}/category/get`).then((res) => {
            if (res.data && res.data.data) {
                const allCategories = res.data.data;

                // 1. Lọc danh mục có stt == 0 (Đứng trước "Tất cả")
                const catBeforeAll = allCategories
                    .filter(cat => Number(cat.stt) === 0)
                    .map(cat => cat.name);

                // 2. Lọc danh mục có stt >= 1 (Đứng sau "Tất cả")
                const catAfterAll = allCategories
                    .filter(cat => Number(cat.stt) !== 0)
                    .map(cat => cat.name);

                // 3. Ghép mảng hoàn chỉnh
                const finalCategories = [...catBeforeAll, "Tất cả", ...catAfterAll];
                setCategories(finalCategories);

                // 4. CHUẨN UX: Tự động Active cái danh mục đứng đầu tiên
                if (finalCategories.length > 0) {
                    setActiveCategory(finalCategories[0]);
                }
            }
        });
    }, []);

    // Cấu hình cho Swiper banner
    const swiperParams = {
        modules: [Autoplay, Pagination],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: { clickable: true },
    };

    return (
        <>
            <Header profile={profile} />

            <style>{`
                /* NỀN DARK THEME */
                .promo-page-wrapper {
                    background-color: #1b1e36;
                    min-height: 100vh;
                    font-family: 'Montserrat', sans-serif;
                    padding-bottom: 50px;
                }
                
                /* BANNER ĐỘNG FULL WIDTH */
                .main-banner-wrap {
                    width: 100%;
                    overflow: hidden;
                    margin-bottom: 30px;
                    background-color: #111429;
                }
                .swiper-pagination-bullet { background: #fff; opacity: 0.5; }
                .swiper-pagination-bullet-active { background: #00e5ff; opacity: 1; }

                /* CONTAINER CHÍNH */
                .promo-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 15px 30px;
                }

                /* HEADER: Tiêu đề Khuyến Mãi + Nút Quay Lại */
                .promo-header-top {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 25px;
                }
                .btn-back {
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    color: #8da4d0;
                    font-weight: bold;
                    cursor: pointer;
                    font-size: 16px;
                    transition: 0.3s ease;
                }
                .btn-back:hover {
                    color: #00e5ff;
                }
                .promo-main-title {
                    font-size: 26px;
                    font-weight: 900;
                    color: #00e5ff;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                /* ========================================= */
                /* THANH LỌC CHUYÊN MỤC (DARK THEME)         */
                /* ========================================= */
                .promo-category-bar {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    overflow-x: auto;
                    margin-bottom: 25px;
                    padding-bottom: 5px; 
                    scrollbar-width: none; 
                }
                .promo-category-bar::-webkit-scrollbar {
                    display: none; 
                }

                .promo-cat-btn {
                    display: inline-block;
                    min-width: max-content;
                    height: 38px;
                    line-height: 36px; 
                    padding: 0 20px;
                    color: #8da4d0;
                    font-size: 14px;
                    font-weight: bold;
                    text-align: center;
                    border: 1px solid #3a3f63;
                    border-radius: 20px;
                    cursor: pointer;
                    background: #24294d;
                    transition: all 0.3s ease;
                    white-space: nowrap;
                    text-transform: uppercase;
                    box-sizing: border-box; 
                }
                .promo-cat-btn:hover {
                    border-color: #00e5ff;
                    color: #fff;
                }

                .promo-cat-btn.active {
                    background: #00e5ff; 
                    color: #111429; 
                    border-color: #00e5ff;
                    box-shadow: 0 4px 10px rgba(0, 229, 255, 0.3); 
                }
                /* ========================================= */

                /* LƯỚI ẢNH KHUYẾN MÃI (2 CỘT) */
                .promo-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 25px;
                }
                .promo-card {
                    cursor: pointer;
                    border-radius: 12px;
                    overflow: hidden;
                    background: #24294d;
                    border: 1px solid #3a3f63;
                    transition: transform 0.3s ease, border-color 0.3s ease;
                }
                .promo-card:hover {
                    transform: translateY(-5px);
                    border-color: #00e5ff; 
                }
                .promo-card img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }

                /* RESPONSIVE */
                @media (max-width: 768px) {
                    .promo-grid {
                        grid-template-columns: 1fr; 
                        gap: 20px;
                    }
                    .promo-main-title {
                        font-size: 20px;
                    }
                    .btn-back {
                        font-size: 14px;
                    }
                    .main-banner-wrap {
                        margin-bottom: 15px;
                    }
                }

                /* POPUP STYLES DARK THEME */
                .custom-popup-backdrop {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0, 0, 0, 0.7);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                    backdrop-filter: blur(4px);
                }
                .custom-popup-main {
                    background: #1b1e36;
                    width: 90%;
                    max-width: 600px;
                    max-height: 85vh;
                    border-radius: 16px;
                    overflow: hidden;
                    border: 1px solid #3a3f63;
                    display: flex;
                    flex-direction: column;
                }
                .custom-popup-header {
                    background: #24294d;
                    color: #00e5ff;
                    padding: 15px 20px;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    border-bottom: 1px solid #3a3f63;
                }
                .custom-popup-content {
                    padding: 20px;
                    overflow-y: auto;
                    flex: 1;
                    font-size: 14px;
                    line-height: 1.6;
                    color: #d1d5db;
                }
                .custom-popup-content img {
                    max-width: 100%;
                    height: auto;
                    border-radius: 8px;
                    margin-bottom: 15px;
                }
                .btn-close-popup {
                    background: #ff5050;
                    color: white;
                    border: none;
                    width: calc(100% - 40px);
                    margin: 15px 20px;
                    padding: 12px;
                    font-size: 16px;
                    font-weight: bold;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: 0.2s;
                }
                .btn-close-popup:hover {
                    background: #cc0000;
                }
            `}</style>

            <div className="promo-page-wrapper">
                
                {/* BANNER ĐỘNG TỪ API (CHỈ HIỂN THỊ BANNER TRANG CHỦ) */}
                {notify && notify.length > 0 && (
                    <div className="main-banner-wrap">
                        <Swiper {...swiperParams}>
                            {notify.map((item, index) => {
                                if (item.isShow === true && item.displayLocation === "home") {
                                    return (
                                        <SwiperSlide key={index}>
                                            <img 
                                                alt={item.title ? item.title.replace(/[{}]+/g, "") : "Banner"} 
                                                src={item.image} 
                                                style={{ width: "100%", maxHeight: "500px", objectFit: "cover", display: "block" }} 
                                            />
                                        </SwiperSlide>
                                    )
                                }
                                return null;
                            })}
                        </Swiper>
                    </div>
                )}

                <div className="promo-container">
                    
                    {/* Header Khuyến Mãi */}
                    <div className="promo-header-top">
                        <div className="btn-back" onClick={() => navigate(-1)}>
                            <span>&#10094;</span> Quay lại
                        </div>
                        <div className="promo-main-title">
                            Khuyến mãi
                        </div>
                    </div>

                    {/* THANH DANH MỤC LỌC KHUYẾN MÃI */}
                    {categories.length > 0 && (
                        <div className="promo-category-bar">
                            {categories.map((cat, index) => (
                                <button
                                    key={index}
                                    className={`promo-cat-btn ${activeCategory === cat ? "active" : ""}`}
                                    onClick={() => setActiveCategory(cat)}
                                >
                                    {cat}
                                </button>
                            ))}
                        </div>
                    )}

                    {/* Lưới Banner Khuyến Mãi (2 cột) */}
                    <div className="promo-grid">
                        {notify.map((item, index) => {
                            // CHỈ HIỂN THỊ THÔNG BÁO, BỎ QUA BANNER TRANG CHỦ VÀ POPUP/MARQUEE
                            if (
                                item.title !== "marquee" && 
                                item.title !== "popup" && 
                                item.title !== "Banner" && 
                                item.isShow === true &&
                                item.displayLocation !== "home"
                            ) {
                                
                                // LỌC THEO DANH MỤC
                                if (activeCategory !== "Tất cả" && item.category !== activeCategory) {
                                    return null;
                                }

                                return (
                                    <div
                                        key={index}
                                        className="promo-card"
                                        onClick={() => {
                                            if (item.title.indexOf("{") !== 0) {
                                                setNotifyItem(item);
                                                setShow(true);
                                            } else {
                                                navigate(item.content.replace(/<\/?[^>]+(>|$)/g, ""));
                                            }
                                        }}
                                    >
                                        <img alt={item.title.replace("}", "").replace("{", "")} src={item.image} />
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>

                </div>
            </div>

            {/* HIỂN THỊ POPUP CHI TIẾT KHUYẾN MÃI DẠNG DARK THEME */}
            {notifyItem != null && isShow ? (
                <div className="custom-popup-backdrop" onClick={() => setShow(false)}>
                    <div className="custom-popup-main" onClick={(e) => e.stopPropagation()}>
                        <div className="custom-popup-header">
                            {notifyItem.title.replace("}", "").replace("{", "")}
                        </div>
                        <div className="custom-popup-content">
                            {notifyItem.content.indexOf("{") !== -1 && notifyItem.content.indexOf("}") !== -1 ? (
                                <>
                                    <img
                                        src={notifyItem.content.substring(notifyItem.content.indexOf("{") + 1, notifyItem.content.indexOf("}"))}
                                        alt="Promo Detail"
                                    />
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: notifyItem.content.replace(
                                                notifyItem.content.substring(notifyItem.content.indexOf("{"), notifyItem.content.indexOf("}") + 1),
                                                ""
                                            )
                                        }}
                                    />
                                </>
                            ) : (
                                <div dangerouslySetInnerHTML={{ __html: notifyItem.content }} />
                            )}
                        </div>
                        <button onClick={() => setShow(false)} className="btn-close-popup">
                            ĐÓNG
                        </button>
                    </div>
                </div>
            ) : null}
        </>
    );
}

export default Promotion;